import React, { forwardRef, useEffect } from "react";
import "../enquiry/enquiry.scss";
import "react-datepicker/dist/react-datepicker.css";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ViewImageModal from "../../components/enquiry/ViewImageModal";
import ErrorMessage from "../../components/common/ErrorMessage";
import AddNewProjectModal from "../../components/common/AddNewProjectModal";
import AddNewCustomerModal from "../../components/common/AddNewCustomerModal";
import NewEnquiryDetails from "../../components/enquiry/NewEnquiryDetails";
import EnquiryNoOptionsMessage from "../../components/enquiry/EnquiryNoOptionsMessage ";
import useForm from "./useForm";
import { useLocation } from "react-router-dom";

// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
    placeholder="DD/MM/YYYY"
  ></input>
));
// datepicker end

const NewEnquiry = () => {
  const {
    setShowNewProj,
    setShowNewCust,
    selectCustRef,
    values,
    setValues,
    distributorData,
    customerInqName,
    setCustomerInqName,
    setErrors,
    errors,
    handleDocumentChange,
    setCountryInq,
    setAllocatedToInq,
    ErrorDoneClick,
    errorShow,
    setCurrencyInq,
    setProjectInqName,
    setInquiryType,
    setAssignedInqEngineer,
    handleClick,
    setDistributorInq,
    distributorInq,
    filteredCustData,
    handleFormChange,
    countryData,
    countryInq,
    assignedEngineerData,
    allocatedToInq,
    currencyData,
    currencyInq,
    projectInqName,
    selectProjRef,
    inquiryTypes,
    inquiryType,
    handleDueDate,
    assignedInqEngineer,
    handleCheckChange,
    docError,
    removeAttachedFile,
    handleNotesChange,
    handleCancel,
    handleRedirect,
    loading,
    handleSubmit,
    currencyList,
    showNewProj,
    customerList,
    projectList,
    projectData,
    setProjectData,
    distributorList,
    setCustList,
    showNewCust,
    createMsg,
    setCreateMsg,
    setShow,
    show,
    SuccessDoneClick,
    setNewAddedCustomer,
    setNewAddedProject,
    filteredProjData
  } = useForm();

  //No Option Message
  const HandleShowNewProject = () => {
    setShowNewProj(true);
  };
  const HandleShowNewCustomer = () => {
    setShowNewCust(true);
  };
  const location = useLocation();
 
  useEffect(() => {
  window.dispatchEvent(
    new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: values?.id
          ? `Enquiry : ${values?.inquiryRef}`
          : "New Enquiry",
        backTarget: {
          pathname: "/enquiry-list",
        },
      },
    })
  );

  return () => {
    window.dispatchEvent(
      new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      })
    );
  };
}, [
  location.pathname,
  values?.id,
  values?.inquiryRef,
]);
  const NoOptionsMessage = (props) => {
    if (props?.selectProps?.name == "customerInqName") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewCustomer}
          selectRef={selectCustRef}
          Master="Customer Master"
          Name="customer name"
          {...props}
        />
      );
    } else if (props?.selectProps?.name == "projectInqName") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewProject}
          selectRef={selectProjRef}
          Master="Project Master"
          Name="project name"
          {...props}
        />
      );
    }
  };

  return (
    <div className="container-fluid add-new-enquiry-sec pl-3 pr-3">
      {/* NewEnquiryDetails start */}
      <NewEnquiryDetails
        distributorData={distributorData}
        customerInqName={customerInqName}
        setCustomerInqName={setCustomerInqName}
        setValues={setValues}
        values={values}
        setErrors={setErrors}
        errors={errors}
        handleDocumentChange={handleDocumentChange}
        setCountryInq={setCountryInq}
        setAllocatedToInq={setAllocatedToInq}
        setCurrencyInq={setCurrencyInq}
        setProjectInqName={setProjectInqName}
        setInquiryType={setInquiryType}
        setAssignedInqEngineer={setAssignedInqEngineer}
        handleClick={handleClick}
        setDistributorInq={setDistributorInq}
        distributorInq={distributorInq}
        filteredCustData={filteredCustData}
        filteredProjData={filteredProjData}
        NoOptionsMessage={NoOptionsMessage}
        selectCustRef={selectCustRef}
        handleFormChange={handleFormChange}
        countryData={countryData}
        countryInq={countryInq}
        assignedEngineerData={assignedEngineerData}
        allocatedToInq={allocatedToInq}
        currencyData={currencyData}
        currencyInq={currencyInq}
        projectData={projectData}
        projectInqName={projectInqName}
        selectProjRef={selectProjRef}
        inquiryTypes={inquiryTypes}
        inquiryType={inquiryType}
        handleDueDate={handleDueDate}
        ExampleCustomInput={ExampleCustomInput}
        assignedInqEngineer={assignedInqEngineer}
        handleCheckChange={handleCheckChange}
        docError={docError}
        removeAttachedFile={removeAttachedFile}
        handleNotesChange={handleNotesChange}
        handleCancel={handleCancel}
        handleRedirect={handleRedirect}
        loading={loading}
        handleSubmit={handleSubmit}
        currencyList={currencyList}
      />

      {/* addToProjectMasterPopModal  */}
      <AddNewProjectModal
        showNewProj={showNewProj}
        setShowNewProj={setShowNewProj}
        customerData={filteredCustData}
        projectLists={projectList}
        projectData={projectData}
        setProjectData={setProjectData}
        countryData={countryData}
        distributordata={distributorList}
        selectedDistributor={distributorInq}
        setProjectName={setNewAddedProject}
        pageName="Enquiry"
      />

      {/* addToCustomerNamePopModal */}
      <AddNewCustomerModal
        distributorInq={distributorInq}
        setCustList={setCustList}
        disabledDistributor={true}
        showNewCust={showNewCust}
        setShowNewCust={setShowNewCust}
        customerData={customerList}
        distributorData={distributorList}
        countryData={countryData}
        assignedEngineerData={assignedEngineerData}
        pageName="Enquiry"
        setNewAddedCustomer={setNewAddedCustomer}
      />

      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      <ViewImageModal />
    </div>
  );
};

export default NewEnquiry;
